/*
|----------------------------------------------------------
|   Social Media:
|----------------------------------------------------------
|   All functions related to Social media
|
*/

import config from "./config";

export default {

    /**
     * init facebook widgets
     */
    initFacebook: function() {
        if (config.debug) console.log('initSocialMedia');
        FB.XFBML.parse();
    },
    resetMetaData: function(pjax) { ////WPB-4022
        if (config.debug) console.log('resetMetaData');
        // console.log("image here "+document.images[0].src);
        // jQuery("meta[property='og\\:url']").attr("content", window.location.href);
        // jQuery('link[rel="canonical"]').attr('href', window.location.href);
        // jQuery("meta[property='og\\:title']").attr("content", document.title);
        // var metaImage = jQuery("meta[property='og\\:image']");
        // if (typeof metaImage !== typeof undefined && metaImage !== false && metaImage.length > 0 ) {
        //     jQuery("meta[property='og\\:image']").attr("content", document.images[0]);
        // } else {
        //     var link = document.createElement('meta');
        //     link.setAttribute('property', 'og:image');
        //     link.content = document.images[0].src;
        //     document.getElementsByTagName('head')[0].appendChild(link);
        // }
        var headTags = [
            "meta[name='keywords']",
            "meta[name='description']",
            "meta[property^='og']",
            "meta[name^='twitter']",
            "meta[itemprop]",
            "link[itemprop]",
            "link[rel='prev']",
            "link[rel='next']",
            "link[rel='canonical']"
        ].join(',');
        jQuery('head').find(headTags).remove();
        jQuery(pjax.newDocument).find(headTags).appendTo('head');
    }
}
